export const BASE_URL =
  'https://ai-host-agent-api-441046532427.us-central1.run.app'

const API_URL = `${BASE_URL}/chat`
const FEEDBACK_URL = `${BASE_URL}/feedback`

async function parseJsonResponse(response) {
  const text = await response.text()
  if (!text) {
    return {}
  }

  try {
    return JSON.parse(text)
  } catch (error) {
    return { reply: text }
  }
}

/**
 * Sends a message to the synchronous (non-streaming) chat endpoint.
 * The API resolves intent, runs the agent, and returns the full reply in one response.
 */
export async function sendChatMessage({
  sessionId,
  messages,
  context,
  senderRole
}) {
  const payload = {
    session_id: sessionId || undefined,
    messages,
    context
  }
  if (senderRole) {
    payload.sender_role = senderRole
  }

  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(payload)
  })

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`Chat API failed: ${response.status} ${error}`)
  }

  return parseJsonResponse(response)
}

/**
 * Fetches available LLM providers and models from GET /models.
 */
export async function getAvailableModels() {
  const response = await fetch(`${BASE_URL}/models`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`Models API failed: ${response.status} ${error}`)
  }

  return parseJsonResponse(response)
}

export async function sendChatFeedback({
  messageId,
  rating,
  comment = null,
  reasons = []
}) {
  const response = await fetch(FEEDBACK_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      message_id: messageId,
      rating,
      comment,
      reasons
    })
  })

  if (!response.ok) {
    const error = await response.text()
    throw new Error(`Feedback API failed: ${response.status} ${error}`)
  }

  return response.json()
}
